import { useEffect, useMemo, useState } from 'react';
import { getAssignmentStatusListByStudent } from '../../../../api/utils/lms/recitation/api';
import { AssignmentStatusByStudentItem } from '../../../../constants/types/lms/recitation/type';
import { useAppDispatch } from '../../../../store/hook';
import { openAlert } from '../../../../store/features/modalSlice';
import { getErrorMessages } from '../../../../api/utils/util-func';
import { useParams } from 'react-router-dom';
import { LoadingSpinner } from '../../../Loading/LoadingSpinner';
import StudentListContents from './StudentListContents';
import StatusByStudentContents from './StatusByStudentContents';
import { AssignmentType } from '../../../../constants/types/lms/type';

/**
 * 개편 LMS (교사) - AI인증제 관리 > AI인증제 현황 페이지 > 학생 선택 판넬
 */
const RecitationStudentPanel = () => {
  const { classId } = useParams();

  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [studentList, setStudentList] = useState<
    AssignmentStatusByStudentItem[]
  >([]);

  useEffect(() => {
    if (!classId) return;

    const fetchAssignmentStudentList = async () => {
      try {
        setIsLoading(true);

        const response = await getAssignmentStatusListByStudent({
          classId,
          toDoStatus: undefined,
          toDoType: AssignmentType.JEBS_AI_RECITATION,
        });

        setStudentList(response.result ?? []);
      } catch (error) {
        dispatch(openAlert({ message: getErrorMessages(error) }));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAssignmentStudentList();
  }, [classId, dispatch]);

  const [selectedStudentId, setSelectedStudentId] = useState<number | null>(
    null,
  );

  const selectedStudent = useMemo(() => {
    if (!selectedStudentId) return undefined;

    return studentList.find(
      (studentItem) => studentItem.id === selectedStudentId,
    );
  }, [selectedStudentId]);

  const handleStudentClick = (classId: number) => {
    setSelectedStudentId(classId);
  };

  const handleBack = () => {
    setSelectedStudentId(null);
  };

  if (isLoading) {
    return <LoadingSpinner message="데이터 조회중" />;
  }

  return (
    <>
      {selectedStudent ? (
        <StatusByStudentContents
          selectedStudent={selectedStudent}
          handleBack={handleBack}
        />
      ) : (
        <StudentListContents
          studentList={studentList}
          handleStudentClick={handleStudentClick}
        />
      )}
    </>
  );
};

export default RecitationStudentPanel;
